import React from 'react';
import { FieldArray, FormikProps } from 'formik';
import PackagingMaterialList from './PackagingMaterialList';
import { RawMaterialProps } from 'enums/RawMaterialEnums';
import { Origin, rawMaterialPayload } from '../CreateProductFlowInterfaces';
import { RawMaterialPackagingMeta } from 'models/RawMaterialPackagingMeta/rawMaterialPackagingMeta.model';
import { Product } from 'models/Product/product.model';
import styles from './CreateProductFlow.module.scss';

interface PackagingMaterialContainerProps {
  rawMateialPackagingMeta: RawMaterialPackagingMeta[];
  handleOpenRequestPackageMaterialModal: () => void;
  isDisabled: boolean;
  fetchData: (params?: { 'input-field': string }) => void;
  showLocationModal: (
    index: number,
    type: string,
    selectedAddress?: Origin[],
    selectedRecordIndex?: number,
    selectedRecordType?: string,
    selectedOriginIndex?: number
  ) => void;
  handleAddOrigins: (
    formikProps: FormikProps<rawMaterialPayload>,
    index: number,
    type?: string,
    id?: string
  ) => void;
  handleRemoveOrigins: (
    formikProps: FormikProps<rawMaterialPayload>,
    index: number,
    originIndex: number,
    type?: string
  ) => void;
  newProduct: Product | undefined;
  formikProps: FormikProps<rawMaterialPayload>;
}

const PackagingMaterialContainer: React.FC<PackagingMaterialContainerProps> = ({
  rawMateialPackagingMeta,
  handleOpenRequestPackageMaterialModal,
  isDisabled,
  fetchData,
  showLocationModal,
  handleAddOrigins,
  handleRemoveOrigins,
  newProduct,
  formikProps,
}) => {
  return (
    <div className={styles.packagingMaterialFormContainer}>
      <FieldArray name={RawMaterialProps.PACKAGE_MATERIAL}>
        {arrayHelpers => (
          <PackagingMaterialList
            rawMateialPackagingMeta={rawMateialPackagingMeta}
            handleOpenRequestPackageMaterialModal={
              handleOpenRequestPackageMaterialModal
            }
            isDisabled={isDisabled}
            arrayHelpers={arrayHelpers}
            fetchData={fetchData}
            showLocationModal={showLocationModal}
            handleAddOrigins={handleAddOrigins}
            handleRemoveOrigins={handleRemoveOrigins}
            newProduct={newProduct}
          />
        )}
      </FieldArray>
    </div>
  );
};

export default PackagingMaterialContainer;
